import { Form, required, useNotify, useUpdate } from "ra-core";
import { useWatch } from "react-hook-form";
import type { FieldValues } from "react-hook-form";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { SaveButton } from "@/components/admin/form";
import type { Contact } from "@/components/atomic-crm/types";
import { commercialStages, getCommercialStage } from "./workflow";

export const CommercialInputs = () => {
  const stage = useWatch({ name: "commercial_stage" });
  return (
    <>
      <SelectInput
        source="commercial_stage"
        label="Fase commerciale"
        choices={[...commercialStages]}
        translateChoice={false}
        validate={required()}
        helperText={false}
      />
      {stage === "archived" && (
        <TextInput
          source="archived_reason"
          label="Motivo dell’archiviazione"
          validate={(value) => (value?.trim() ? undefined : "Indica il motivo")}
          helperText={false}
        />
      )}
    </>
  );
};

export const NarsStageControl = ({ contact }: { contact: Contact }) => {
  const [update] = useUpdate();
  const notify = useNotify();
  return (
    <Form
      record={{ ...contact, commercial_stage: getCommercialStage(contact) }}
      onSubmit={async (values: FieldValues) => {
        try {
          await update(
            "contacts",
            {
              id: contact.id,
              data: {
                commercial_stage: values.commercial_stage,
                archived_reason:
                  values.commercial_stage === "archived"
                    ? values.archived_reason?.trim()
                    : null,
              },
              previousData: contact,
            },
            { returnPromise: true },
          );
          notify("Fase aggiornata");
        } catch {
          notify("Fase non salvata. Riprova.", { type: "error" });
        }
      }}
      className="flex flex-wrap items-end gap-3"
    >
      <CommercialInputs />
      <SaveButton label="Aggiorna fase" />
    </Form>
  );
};
